import { render } from "./footer-steps.vue?vue&type=template&id=c94cd0d8"
import script from "./footer-steps.vue?vue&type=script&lang=js"
export * from "./footer-steps.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__